import { HardHat, ClipboardList, Gem, Handshake, ShieldCheck } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { PILLARS } from "../../data/site";

const ICONS = { HardHat, ClipboardList, Gem, Handshake, ShieldCheck };

export const Perche = () => (
  <section data-testid="perche-section" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHeading
        number="03"
        overline="Perché noi"
        lines={["Perché scegliere", "Costruzioni Ciosko"]}
      />
      <div className="mt-12 lg:mt-16 border-t border-steel">
        {PILLARS.map((p, i) => {
          const Icon = ICONS[p.icon];
          return (
            <Reveal key={p.title} delay={i * 0.05}>
              <div
                data-testid={`pillar-${p.title.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
                className="group grid grid-cols-[auto_1fr] sm:grid-cols-[80px_64px_1fr] lg:grid-cols-[100px_80px_320px_1fr] items-center gap-x-5 sm:gap-x-8 py-6 sm:py-7 border-b border-steel transition-colors duration-300 hover:bg-graphite/60"
              >
                <span className="font-mono text-xs text-cement/60 hidden sm:block">{String(i + 1).padStart(2, "0")}</span>
                <span className="w-11 h-11 flex items-center justify-center border border-steel text-forest-glow transition-colors duration-300 group-hover:border-forest-glow" aria-hidden="true">
                  <Icon size={19} />
                </span>
                <h3 className="font-display font-bold text-lg sm:text-xl uppercase tracking-tight text-white">{p.title}</h3>
                <p className="col-span-2 sm:col-span-1 mt-2 sm:mt-0 text-sm text-cement leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
